.root {
  background: var(--color-secondary);
  display: flex;
  height: 100vh;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.main {
  background: var(--color-surface);
  flex: 1;
  overflow: auto;
  padding: 24px 32px;
}

/* --- Mobile overlay backdrop --- */

.overlay {
  display: none;
}

@media (max-width: 768px) {
  .main {
    padding: 16px;
  }

  .overlay {
    appearance: none;
    background: rgba(0, 0, 0, 0.4);
    border: none;
    cursor: default;
    display: block;
    inset: 0;
    position: fixed;
    z-index: 40;
  }
}
